/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StageAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Stages from './Stages/index'
import TysiaIconArrowForward from 'DesignSystem/Svgs/TysiaIconArrowForward/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StageAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/BulkActions/Content/StageAction",
  closePopover
  
}) {
let selectedBulkStagesValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_stages',
format: fromFormat.isEmptyList,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let selectedBulkStagesValueData1 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_stages',
format: fromFormat.isEmptyList,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let selectedBulkStagesValueData2 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_stages',
format: fromFormat.isEmptyList,
})
let selectedBulkStagesValueData3 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_stages',
format: fromFormat.isNotEmptyList,
})
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 width={260}
 offsetCrossAxis={-232}
 offsetMainAxis={-30}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="StageAction.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-2-1lPmy3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--c-1-1lPmy3': selectedBulkStagesValueData ? "normal" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Move to stage"
 color={selectedBulkStagesValueData1 ? dtColorsNeutral500 : dtColorsNeutral900}
 data="selected.bulk_stages"
 format="/Data/format.js isEmptyList"
/>
<TysiaIconArrowForward
  viewPath={`${viewPath}/TysiaIconArrowForward`}
 width={12}
 height={12}
 fill={selectedBulkStagesValueData2 ? dtColorsNeutral500 : dtColorsNeutral900}
 data="selected.bulk_stages"
 format="/Data/format.js isEmptyList"
/>
</div>
)}
</PopoverTrigger>
<fromFlow.When is={selectedBulkStagesValueData3}>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
 data="selected.bulk_stages"
 format="/Data/format.js isNotEmptyList"
>
{childProps => (
<Stages
{...childProps}
  viewPath={`${viewPath}/Stages`}
 closePopover={closePopover}
/>
)}
</PopoverContentLeftClick>
</fromFlow.When>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}